// Action-level permission helper for the admin panel.
//
// Reads the logged-in admin (sessionStorage "user") and returns what they may
// DO inside a given module. Full "Admin" accounts (the superadmin) bypass every
// check; "Member" accounts are limited to their stored module_permissions.
//
// Module keys: documents | assessments | tickets | bookings | team
export function getAdminPerms(moduleKey) {
  let user = {};
  try {
    user = JSON.parse(sessionStorage.getItem("user") || "{}");
  } catch {
    user = {};
  }

  const isSuperAdmin = (user?.role_type || "") === "Admin";
  const all =
    user?.module_permissions && typeof user.module_permissions === "object"
      ? user.module_permissions
      : {};
  const p = all[moduleKey] || {};

  return {
    canView: isSuperAdmin || p.view === true,
    canAdd: isSuperAdmin || p.add === true,
    canEdit: isSuperAdmin || p.edit === true,
    canDelete: isSuperAdmin || p.delete === true,
  };
}
